import { useGetOne } from "venue-react"

export const useGetPromotion = (id: string) => {
  return useGetOne("promotion", id, { populate: true })
}
